const zhTW = {
	"channel": {
		"allChannels": "所有組織",
		"addChannel": "新增組織",
		"goToChannel": "前往組織頁面",
		"channelNameAndPhoto": "組織照片與名稱",
		"channelName": "組織名稱",
		"memberInChannel": "組織成員",
		"addMember": "新增成員",
		"addMemberTitle": "新增組織成員",
		"inviteMemberByEmail": "透過電子信箱邀請組織成員",
		"typeEmail": "請輸入電子信箱",
		"inviting": "邀請中",
		"admin": "管理者", // need match role name in permissionEnum
		"op": "一般會員",
		"csr": "客服人員",
		"friends": "朋友",
		"messages": "總訊息數",
		"linePhotoDes": "圖像與名稱僅供內部人員辨識使用。如果您要設定紛絲看到的 LINE@ 圖像及名稱，請至",
		"lineManager": "LINE@ Manager",
		"callOp": "一對一需求",
		"noMoreNotify": "沒有更多訊息了",
		"noMoreNewNoti": "沒有新訊息",
		"market": "行銷專區",
		"members": "會員資料"
	},
	"tags": {
		"title": "標籤管理",
		"tagsManagementDes": "可於此頁面進行標籤的分類、新增、修改等動作，以達到有效管理標籤 ; 其中前有 * 的標籤為科威後台系統自動產生，不提供修改功能。",
		"unClassify": "未分類標籤",
		"addTagsWithName": "新增「 {{tagName}} 」標籤",
		"addTags": "新增標籤",
		"friendsHasTheTag": "{{friendsNumber}} 位好友有此標籤",
		"addClass": "新增分類",
		"deleteTagConfirm": "共 {{friendsNumber}} 位好友擁有此標籤\n您確定要刪除嗎？",
		"modifyTagConfirm": "將 {{friendsNumber}} 位好友所擁有的 \" {{tagNameA}} \" 標籤\n修改為 \" {{tagNameB}} \"。",
		"mergeTagConfirm": "將 {{friendsNumber}} 位好友所擁有的 \" {{tagNameA}} \" 標籤\n修改為已存於標籤庫中的 \" {{tagNameB}} \"。",
		"modifyTagConfirmWithTagExist": "將 26 位好友擁有的 \" {{tagNameA}} \" 標籤\n 修改為已存於標籤庫中的 \" {{tagNameB}} \"。",
		"deleteDirNoti": "只有在分類下沒有任何標籤與分類\n的情況，才能刪除標籤分類",
		"deleteDirDes": "請將標籤或分類移至其他分類",
		"dirMoveLimit": "本次排序移動導致分類\n超出 3 層限制",
		"dirMoveLimitDes": "請減少移動層數",
		"duplicateTag": "此標籤已經存在於資料庫中\n請勿重複建立",
		"duplicateTagDes": "標籤在 {{tagDirCrumblePath}} 中",
		"searchTags": "搜尋標籤",
		"notCreateTag": "尚未建立過此標籤",
		"dirLevelMax": "至多 3 層"
	},
	"autoAssignKeyword" : {
		"title" : "關鍵字設定",
		"des" : "可於此頁面進行自動派工關鍵字的新增、修改等動作。",
		"search": "搜尋關鍵字",
		"viewAllKeyword": "瀏覽所有關鍵字",
		"addKeyword" : "新增關鍵字",
		"addKeywordUnder" : "在{{parent}}下新增",
		"noMatchKeyword" : "沒有相符的關鍵字",
		"noDuplicate" : "此標籤 {{tagText}} 已經存在於資料庫中\n請勿於不同層級重複建立",
		"confirmDelete": "共 {{useOperatorCount}} 位專員擁有此關鍵字\n並且此關鍵字包含 {{childCount}} 個子關鍵字\n您確定要刪除嗎？",
		"recent20": "最近常用 20 個關鍵字：",
		"all": {
			"title": "所有關鍵字",
			"des" : "瀏覽所有關鍵字。"
		},
		"level" : {
			0: "國家",
			1: "地區",
			2: "景點"
		}
	},
	"activity": {
		"title": "活動 QRcode",
		"description": "設定活動資訊並產生 QRcode ，作為行銷宣傳工具，顧客參與活動將會自動轉換成顧客標籤，也可利用關鍵字功能發送給旅客。有效追蹤活動參與人數。",
		"newActivity": "新增",
		"createActivity" : {
			"normal" : "新增一般活動",
			"vote" : "新增投票活動"
		},
		"activityListType" : {
			"normal" : "一般活動",
			"vote" : "投票活動"
		},
		"status": {
			"unStart": "未使用",
			"active": "使用中",
			"expired": "已過期",
			"deleted": "已刪除"
		},
		"normalActivity" : "一般活動",
		"voteActivity" : "投票活動",
		"activityDate": "活動期間",
		"notAssign": "無限期",
		"specificDay": "指定截止日",
		"numberOfAttendees": "活動人數",
		"numberOfVote": "投票人數",
		"setting": "內容設定",
		"downloadNstatistics": "下載與統計",
		"activityName": "活動名稱",
		"activityDateDes": "為避免投票結果失效，活動開始後只能修改觸發語句、卡片圖示和截止/刪除後回覆，若刪除投票，僅能修改截止/刪除後回覆設定。",
		"triggerDes": "設定自動觸發語句，可讓無法直接掃描 QRcode 的顧客，透過輸入設定好的觸發語句，參與相關活動。\n特別注意：活動間觸發語句請勿重複使用，系統將會觸發符合觸發語句的所有活動中，開始時間最近的活動。",
		"activityCover": "活動卡片圖示",
		"activityCoverDes": "圖片尺寸：1024 x 680 px\n圖片大小：小於1 MB\n檔案格式：jpg / png",
		"activityVoteSetting" : "投票設定",
		"activityVoteSettingDes" : "特別注意：投票類型轉換，可能導致儲存過的選項因格式不符而遺失，請勿隨意變更選定的投票類型。",
		"voteSetting" : {
			"selectionType" : "選項",
			"single": "單選",
			"multiple" : "多選",
			"optionType": "類型",
			"text": "一般投票",
			"date": "日期投票",
			"publishResult" : "公開投票結果 ( 旅客在投票前後是否看得到總結果 )",
			"voteOption" : "投票選項",
			"voteOptionDes" : "自訂選擇項目並為它加上專屬標籤，追蹤顧客喜好更精準。",
			"newVoteOption" : "新增選項"
		},
		"activityTags": "活動標籤",
		"activityTagsDes": "顧客掃描 QRcode 或觸發語句後，透過 Line 同意進入活動相關畫面，一般活動將自動幫顧客加上活動標籤 ; 投票活動則須完成投票動作才會加上。",
		"activityMsgs": "活動招呼語",
		"expiredText": "截止/刪除後的回覆",
		"expiredTextDes": "當顧客於活動期間截止後掃描 QRcode 或輸入觸發語句，或在活動刪除後掃描 QRcode，系統將自動回覆您事先設定好的回覆內容。",
		"atLeastOneQuestion": "請至少新增一個文字說明做為活動的觸發語句",
		"downloadQRcode": "QRcode 下載",
		"qrcodeInfo": "下載尺寸：600 x 600 px ( 含 QRcode 範圍 450 x 450 px )\n容錯率：7%\n檔案格式：jpg",
		"statistic": "統計",
		"peoplePerDay": "每日人數",
		"peoplePerDayChartDes": "由區間結束日期回推，最多呈現30天",
		"total": "總人數",
		"oldMember": "舊會員",
		"newMember": "新會員",
		"participateWays": "參與方式",
		"scanQRCode": "掃描 QRcode",
		"keywords": "關鍵語句",
		"scanButNotJoin": "參與未加入LINE@",
		"attendees": "參與者",
		"order": "序號",
		"attendeeName": "顧客名稱",
		"newOrOldMember": "新/舊會員",
		"notJoin" : "未加入",
		"firstJoinTime": "首次參與時間",
		"participateCounts": "參與次數",
		"conversation": "對話",
		"downloadAttendees": "下載名單(.csv)",
		"betweenActivity": "期間",
		"deletedAt": "於 {{deleteDate}} 刪除",
		"voteActivityState": {
			"isDelete": "活動已刪除",
			"isNotStart": "活動尚未開始",
			"ongoingWithEndDtm": "剩下{{dateLeft}}天",
			"ongoing": "活動進行中",
			"hasVote": "投票完成，共{{voteCount}}人參與投票",
			"isEnd": "活動已結束",
		},
		"votePage": {
			"send" : "送出",
			"close" : "關閉",
			"cancel" : "取消",
			"activityNotStart-1" : "活動將於",
			"activityNotStart-2" : "月",
			"activityNotStart-3" : "日開始",
			"activityNotStart-4" : "敬請期待"
		},
		"voteCompelete": "投票完成",
		"chooseActivity" : "選擇活動",
		"votDoneKeyword" : "投票完成關鍵字",
		"votDoneKeywordDes" : "Line使用者投票完成後會將此關鍵字帶入Line聊天室的訊息輸入匡。",
		"votDoneReply" : "投票完成回覆",
		"votDoneReplyDes" : "頻道收到包含投票完成關鍵字的訊息後的回覆設定，若不同活動的關鍵字有重複，將以活動開始日期最早的排序為主。",
		"linkUrl" : "連結網址",
		"voteResult" : "投票結果",
		"voteUnit" : "票",
		"voteResultIllustration" : "選項票數 (張)"
	},
	"setting": {
		"title": "組織設定",
		"line@": "LINE@設定",
		"connected": "已連接",
		"unset": "未連接",
		"connectedAccount": "已連接帳號名稱",
		"connectSetting": "連接設定",
		"welcomeMsg": "首次對話即時回應",
		"welcomeMsgDes": "讓顧客在第一次開啟與您的對話時，或是加入好友時，收到您親切的問候。",
		"deleteMember": "",
		"unSettingTitle": "尚未連接",
		"unSetting": "您尚未設定 LINE@ 帳號，前往",
		"notAdmin": "你不是管理員。",
		"initAssignOp": "預設客服人員",
		"initOpDes": "當有新好友加入時，若有對話需求將會通知預設客服人員。",
		"selectDefault": "請選擇預設客服",
		"header" : {
			"cowellAccount" : "科威帳號 ({{opNumber}})",
			"googleAccount" : "Google帳號 ({{opNumber}})",
			"permission" : "系統權限",
			"token" : "Notify 存取權杖",
			"toTutorial" : "Line Notify申請教學"
		},
		"notify": {
			"newMessageNotify" : "新訊息通知",
			"newMessageNotifyDes" : "當有顧客傳送訊息時，將發送通知到Line Notify權杖綁定的群組。",
			"lineToken" : "Line Notify 存取權杖",
			"lineTokenPlaceHolder" : "Line Nofity Token",
			"sendToInChargeOp" : "是否傳送通知給聊天室指派負責人",
			"unreplyMessageNotify" : "未回覆訊息通知",
			"unreplyMessageNotifyDes" : "每十分鐘統計經過五分鐘尚被未回覆的顧客訊息，若經查詢有未回覆之訊息內容，系統將發送通知到Line Notify權杖綁定的個人訊息或Line群組，即時通知負責人員，提昇顧客滿意度",
			"activeTime" : "通知啟用時段",
			"activeTimeDes" : "在此時間區間內才會統計並發送未回覆訊息的通知",
			"to" : "到",


		}
	},
	"line@setting": {
		"line@UnsetDes": "您尚未設定 LINE@ 帳號，前往",
		"line@Subtitle": "LINE@ 連結設定",
		"line@Des": "LINE@ 是一個讓人們與朋友圈和商家聯繫起來的訊息類型應用程式，連接應用程式後，您的顧客可以透過Line 跟您的團隊聊天。",
		"step": "步驟",
		"step1Title": "確認帳號方案類型",
		"step1DesPart1": "拜訪",
		"step1DesPart2": "LINE developers",
		"step1DesPart3": "，登入您的 LINE@ 帳號並進入 Provider 的 Channel settings 頁面，滑到",
		"step1DesPart4": "Basic information",
		"step1DesPart5": "標題下的",
		"step1DesPart6": "Available features",
		"step1DesPart7": "，確認您可以使用「PUSH_MESSAGE」的功能。",
		"step1DesPart8": "如果您無法使用 PUSH_MESSAGE 功能，請將您的 LINE@ 帳號版本升級至 Developer Trial、進階版（API）或專業版（API）其中之一。",
		"step2Title": "複製貼上Channel ID",
		"step2DesPart1": "找到",
		"step2DesPart2": "Channel ID",
		"step2DesPart3": "，將字串複製到下面的輸入框中。",
		"channelIdPlaceholder": "在這裡貼上您的Channel ID",
		"step3Title": "複製貼上Channel Secret",
		"step3DesPart1": "找到",
		"step3DesPart2": "Channel Secret",
		"step3DesPart3": "，將字串複製到下面的輸入框中。",
		"channelSecretPlaceholder": "在這裡貼上您的Channel Secret",
		"step4Title": "複製貼上 Channel Access Token",
		"step4DesPart1": "在同一分頁，找到",
		"step4DesPart2": "Messaging settings",
		"step4DesPart3": "標題下的",
		"step4DesPart4": "Channel access token (long-lived)",
		"step4DesPart5": "欄位，請點下右邊的",
		"step4DesPart6": "。會出現「Issue a new channel access token」，選擇「0 hours」，再按下",
		"step4DesPart7": "，將出現的字串複製貼上到下面的輸入框中。",
		"channelAccessTokenPlaceholder": "在這裡貼上您的Channel Access Token",
		"step5Title": "啟用 Webhooks",
		"step5DesPart1": "在同一分頁，找到 Use webhooks ，將內容修改成",
		"step5DesPart2": "Enabled。",
		"step6Title": "貼上 Webhook URL",
		"step6DesPart1": "按下下面欄位的",
		"step6DesPart2": "複製按鈕，將字串貼到 LINE Developers 頁面上的",
		"step6DesPart3": "Webhook URL",
		"step6DesPart4": "欄位中，並按下",
		"step6DesPart5": "。",
		"step7Title": "貼上 LINE@ ID",
		"step7DesPart1": "拜訪",
		"step7DesPart2": "LINE@ MANAGER",
		"step7DesPart3": "，登入您的帳號。點選您欲連接的 LINE@ 帳號進入LINE@ 管理介面。在畫面左上角您可以找到您的 LINE@ ID。請將 ID 複製貼上到下面欄位。",
		"step7DesPart4": "接著，您只要按下下方的「建立連接」就可以完成LINE@的連接。",
		"lineAtIdPlaceholder": "在這裡貼上您的 LINE@ ID",
		"connect": "建立連接"
	},
	"friends": {
		"title": "好友列表",
		"detail": "詳細資料",
		"cowellMemberMatchDes": "LINE 與科威系統的所有會員列表，透過基本資料進行配對，讓您輕鬆辯認已購買過客戶的 LINE 帳號，也可透過搜尋結果進行群發訊息及名單下載。",
		"searchPlaceholder": "搜尋好友名稱、旅客名稱、電話、團名",
		"advancedFilter": "進階篩選",
		"searchResult": "共 {{searchNumbers}} 筆",
		"broadcastToFriends": "發送訊息給 {{friendsNumber}} 位好友",
		"downloadCSV": "下載名單(.csv)",
		"lastMessageFromLine": "LINE最後互動對話",
		"dataFromLine": {
			"name": "基本資料 - 暱稱",
			"phone": "基本資料 - 電話",
			"email": "基本資料 - 電子郵件",
		},
		"friendTags": "顧客標籤",
		"cowellMemberDetial": "科威會員 / 最近參團",
		"controls": "動作",
		"travelerInfo": "旅人資料",
		"mandarinName": "中文姓名",
		"englishName": "英文姓名",
		"birthday": "出生年月",
		"contactNumber": "聯絡電話",
		"phoneNumber": "手機號碼",
		"email": "電子郵件",
		"lineId": "LINE ID",
		"matchResult": "配對結果",
		"noMatch": "沒有配對紀錄",
		"noMatchDes": "本系統將會自動配對 LINE 好友的電話、email 到科威系統中的旅人資料。您不用手動執行。如您覺得配對結果不如預期，請聯絡我們。",
		"recentTravelRecord": "近期出發團",
		"travelRecord": "參團紀錄",
		"backToMemberList": "回會員總覽",
		"travlePeriod": "共 {{travelDays}} 天",
		"adult": "大",
		"child": "小",
		"baby": "嬰兒",
		"travelFee": "團費共 {{travelFee}} 元",
		"noRecord": "沒有紀錄"
	},
	"broadcast": {
		"title": "群發訊息",
		"newGroupMsg": "新增群發訊息",
		"editGroupMsg": "編輯群發訊息",
		"viewGroupMsg": "檢視群發訊息",
		"sent": "已發送",
		"unsend": "未發送",
		"sending": "發送中",
		"scheduledSendingTime": "預計發送時間",
		"numberOfPeopleSent": "訊息發送人數約",
		"deliverayRate": "送達率",
		"groupMsgName": "群發訊息名稱",
		"msgRecipient": "發送對象",
		"allFriends": "所有好友",
		"allFriendsToolTip": "無論是否使用 Line Bagel 平台聯繫過的所有 LINE@ 好友。",
		"trueFriends": "已互動好友",
		"trueFriendsToolTip": "所有 LINE@ 好友中，使用 Line Bagel 平台聯繫過的好友。",
		"byFilters": "以屬性篩選",
		"friendsFilterResult": "推測對象資料",
		"aboutNumberOfFriends": "約 {{friendsNumber}} 名好友",
		"friendsByFilters": "以屬性篩選發送對象",
		"addFliterBlock": "新增條件縮小範圍",
		"sendingTime": "發送時間",
		"unAssign": "未指定",
		"sendNow": "立即發送",
		"setSendingTime": "指定發送時間",
		"msgContent": "訊息內容",
		"untitled": "未命名群發訊息",
		"include": "包含",
		"notInclude": "不包含",
		"sendFriendList": "群發好友",
		"searchPlaceholder": "請輸入您想搜尋的好友 LINE 暱稱、真實姓名、email 或手機",
		"searchResult": "搜尋 \"{{keyword}} \" ，共 {{resultCounts}} 筆"
	},
	"filter": {
		"tag": "標籤",
		"chatRoomGuid": "LINE 好友",
		"travelDay": "曾經旅遊天數",
		"groupFee": "曾經參加旅遊團費",
		"orderChildrenNumber": "曾經參加小孩數",
		"orderPassengerNumber": "曾經參加人數",
		"passengerAge": "曾經參團的年齡",
		"chatRoomFollowTime": "好友加入時間",
		"area": "曾經旅遊區域",
		"cowellSearch": "科威旅客資訊",
		"cowellSearchPlaceholder": "搜尋好友名稱、旅客名稱、電話、團名",
		"comparePattern": "{{number}}$t(filter.unit.{{name}})$t(filter.compare.{{compare}})",
		"betweenPattern": "{{number1}}-{{number2}}$t(filter.unit.{{name}})",
		"unit": {
			"travelDay": "天",
			"groupFee": "萬",
			"orderChildrenNumber": "位",
			"orderPassengerNumber": "位",
			"passengerAge": "歲",
			"chatRoomFollowTime": "個月"
		},
		"compare": {
			"less": "以下",
			"greater": "以上",
			"equal": " "
		},
		"find": "找",
		"or": "或",
		"tagCountCompare": {
			"greaterThanOrEqual": "大於等於",
			"lessThanOrEqual": "小於等於"
		}
	},
	"message": {
		"title": "訊息中心",
		"all": "全部",
		"friend": "好友",
		"chat": "聊天內容",
		"file": "檔案",
		"tag": "標籤",
		"richImage": "圖文訊息",
		"imagemap": "圖文訊息",
		"activityCard" : "活動卡片",
		"join": "加入聊天",
		"fileSize": "檔案大小",
		"msgType": "訊息類型",
		"text": "文字",
		"sendingFile": "傳送檔案",
		"dragFileHereOr": "請將檔案拖曳到此或是",
		"reDragFileHereOr": "請重新將檔案拖曳到此或是",
		"acceptFileExtension": `上傳說明：
			* 我們支援任何檔案 ( .doc, .docx, .pdf, .xls, .zip, .mp4, .m4a...等 )
			* 檔案大小上限為 128 MB
			* 不支援資料夾上傳
		`,
		"sending": "傳送中",
		"createRichImage": "建立新的圖文訊息",
		"richImgDes": "您可利用圖片傳送具有視覺效果的圖文簡訊。在無法讀取豐富文本格式檔（Rich Text）的裝置上，本訊息內容將會以純文字格式呈現。",
		"msgTitle": "訊息標題",
		"bgImg": "背景圖像",
		"imgRestriction": "10MB 以下的 png,jpg，建議為 1040x1040 像素。",
		"altText": "連結標題",
		"linkUrl": "連結網址",
		"addTags": "加上標籤",
		"after441": "4.4.1以上版本",
		"before441": "4.4.1前版本",
		"moreMessages": "新增更多內容",
		"unrecognized": "無法辨識",
		"uploadFile": "上傳檔案",
		"robotActive": "機器人輔助回答",
		"userProfile": "個人資訊",
		"fileRecord": "檔案記錄",
		"fileSender": "傳送人",
		"fileSendTime": "傳送時間",
		"fileExt": "副檔名",
		"fileDownloadExpiredDate": "下載期限",
		"ExpiredDateFromNow": "即日起至 {{expiredDate}} 止",
		"noOwner" : "尚未指派負責人",
		"removeOwner" : "移除指派負責人",
		"setOwnerToMyself" : "分派給自己",
		"searchFilter" : {
			"type" : {
				"all" : "所有訊息",
				"pending" : "待處理",
				"star" : "關注對話",
				"done" : "處理完畢"
			} ,
			"owner" : {
				"default" : "所有負責人",
				"noOwner" : "未指派的對話"
			}
		},
		"msgIputPlaceHolder" : "輸入訊息",
		"searchValueFilter" : {
			"type" : {
				"userInfo" : "基本內容",
				"tag" : "個人標籤",
				"history" : "聊天內容",
				"cowell": "科威會員"
			}
		},
		"nameInLine" : "LINE 名稱",
		"subName" : "姓名",
		"subNameBriefTitle": "真實姓名：",
		"phone" : "電話",
		"phoneBriefTitle": "行動電話：",
		"email" : "信箱",
		"emailBriefTitle": "電子信箱：",
		"activityName" : "活動名稱：",
		"activityDuration" : "活動期間："
	},
	"file": {
		"loading": "載入中",
		"noFile": "沒有檔案",
		"overExpireDate": "檔案已遺失或是超過90天下載期限，\n如有下載需求，請向客服專員洽詢。",
		"fileDownload": "檔案下載",
		"downloadSuccess": "正常情況下，系統載入完成會自動下載，\n如果沒有，請點擊下面按鈕再試一次。",
		"closeWindow": "關閉視窗",
		"downloadAgain": "再次下載",
		"knowLineBagelMore": "了解 LineBagel 更多",
		"bot": "訊息機器人"
	},
	"dashboard": {
		"title": "Dashboard",
		"overview": "總覽",
		"friends": "個顧客",
		"messages": "則訊息",
		"fourteenDaysRecord": "最近 30 天記錄",
		"people": "人數",
		"conversations": "對話數",
		"illustrationPeople": "增加顧客人數 (人)",
		"illustrationConversations": "對話數 (則)",
		"alreadyFriend": "已互動好友數",
		"messagesCount": "訊息總數",
		"tagsCount": "今日標籤使用量",
		"callOpCount": "今日好友呼叫一對一客服次數",
		"usagePerMonth": "本月使用量",
		"usageTooltip": "有關此訊息量統計數據，請注意以下兩點：\n1. 在此頁面看到的訊息量，是您的 LINE 官方帳號透\n　過 Line Bagel 平台所發出的訊息量，實際收費訊\n　息量請至您 「LINE 官方帳號」 後台查看，最終計\n　價費用皆以官方後台資料為準。\n2. 您自行在 「LINE@ 管理畫面」 或 「LINE 官方帳號」\n　後台使用 「訊息」 功能所發出的訊息量，並不會記\n　錄在 Line Bagel 平台的 「訊息量統計」 頁面中。",
		"chooseLineProgram": "選擇方案",
		"messageSent": "收費訊息數",
		"freeMessage": "免費訊息額度",
		"lowProgramLimit": "*低方案額度上限2,000且無法加購",
		"lineChargeEstimate": "LINE 費用估算",
		"todaySession": "訊息段落",
		"sessionCount": "數目",
		"sessionPeriod": "平均長度",
		"sessionMsgCount": "平均訊息數",
		"sessionTooltip": "訊息段落是與好友的每次對話。當對話間隔超過 10 分鐘，會被區分成不同的訊息段落。",
		"matchCowell": "科威旅客與LINE好友",
		"matchCowellTooltip": "使用科威旅客配對系統後，將會以科威系統內的旅客資料自動匹配 LINE 好友的電話、email，讓您輕鬆辨認已購買過客戶的 LINE 帳號。",
		"matchPercent": "好友配對率",
		"matchCount": "好友配對總數",
		"travelercount": "科威旅客總數",
		"multiCast": "群發訊息",
		"multiCastCount": "發送次數",
		"friendsTouchCount": "接觸好友數",
		"multiCastTotalMsgCount": "總共發送訊息數",
		"activeFriend": "活躍好友",
		"activeFriendTooltip": "活躍好友的計算方式為好友在每日說過的話總數，依照高到低排序。",
		"activeTag": "活躍標籤",
		"activeTagTooltip": "活躍標籤的計算方式為擁有該標籤的好友的每日對話總數，依照總數由高到低排序",
		"activeQuestion": "機器人熱門問題",
		"activeQuestionTooltip": "機器人熱門問題為 QA 問答機器人最常回答的問題。",
		"unrecognizedQuestion": "機器人無法回答的客戶詢問",
		"unrecognizedTooltip": "七天內，機器人無法回答的問題。",
		"todayUserStatics": "今日會員資料表單相關統計",
		"finishFormCount": "填寫會員資料好友數",
		"matchCowellCount": "科威好友配對數",
		"openFormCount": "開啟次數"
	},
	"lineProgram": {
		"low": "低 (免費)",
		"mid": "中",
		"high": "高"
	},
	"bot": {
		"title": "訊息機器人",
		"funcDes": "只要簡單設定，機器人就能協助您大部分的重複任務。只要能掌握低階的溝通任務，機器人就能有效減少真人客服需要處理的數量。",
		"isClose": "已關閉",
		"isActive": "已啟用",
		"greeting": "加入好友招呼語",
		"greetingDes": "讓顧客在加入好友時，收到您親切的問候。",
		"form": "旅客資料表單",
		"formDes": "您可以將需要旅客輸入的資料製作成表單，利用招呼語功能或者推撥功能發送給旅客。旅客填完之後，資料將會自動轉換成旅客標籤。",
		"oneToOne": "一對一對話招呼語",
		"oneToOneDes": "當旅客要求使用一對一對話時，系統將會自動回覆下列的訊息。請旅客稍等一下，為您爭取一些回覆的時間。",
		"qna": "常見問題 Q & A",
		"qnaDes": "當顧客輸入常見問題時，由機器人自動篩選最適合回答即時為顧客解答。",
		"default": "回答無法處理的問題",
		"defaultDes": "當旅客問出機器人無法回答的問題時，將會由此機器人接手，協助將客戶導引至一對一談話。",
		"stickerReply": "貼圖識別招呼語",
		"stickerReplyDes": "在 LINE 系統限制下，當好友傳送貼圖時，我們無法辨識貼圖涵義，為了避免訊息內容落差或誤解，將由此機器人自動回覆貼圖訊息。",
		"enterKeyword": "請輸入關鍵字",
		"searchResult": "共 {{searchNumbers}} 筆",
		"downloadTemplate": "下載範本(.csv)",
		"importFile": "匯入檔案(限.csv)",
		"question": "Q 問題",
		"answer": "A 回答",
		"enterQuestions": "新增問題的各種問法",
		"possibleQuestion": "可能的問題",
		"acceptFileExtension": `支援的檔案類型為：
			* .csv (純文字)
		`,
		"sheetDesign": "問題設計",
		"sheetSetting": "表單設定",
		"msgType": "訊息類型",
		"sheetFieldType": {
			"text": "文字",
			"image": "圖片",
			"input": "輸入框"
		},
		"sheetPolicy" : {
			"noti-1" : "送出視同您以詳閱並同意本公司之",
			"noti-2" : "及",
			"noti-3" : "，包含Cookie的使用。",
			"policy" : "隱私權政策",
			"terms" : "會員服務條款"
		},
		"displayTitle": "欄位標題",
		"displayDescription": "欄位說明",
		"displayTags": "標籤選項",
		"dataColumnName": {
			"title": "標題區塊",
			"description": "說明區塊",
			"image": "顯示圖片",
			"subName": "真實姓名",
			"birthday": "出生年月日",
			"phone": "電話號碼",
			"email": "電子郵件",
			"tags": "標籤勾選"
		},
		"tagPlaceholder": "輸入標籤名稱，按下 Enter 新增",
		"addMore": "新增更多內容",
		"copySheetUrl": "複製表單連結",
		"sheetUrlDes": "您可以將此表單的連結直接發送給客戶，或是利用招呼語功能導引顧客填寫。",
		"setTriggerQuestion": "設定自動觸發語句",
		"triggerDes": "當客戶輸入您事先設定好的自動觸發語句時，就能自動將訊息傳送給客戶。",
		"triggerQuestion": "觸發語句",
		"reply": "回覆內容",
		"chooseType": "請選擇類型",
		"oneToOneRespone": "收到一對一對話需求時的回應 (最多 5 則)",
		"atLeastOneQuestion": "請至少新增一個做為開啟一對一模式文字說明",
		"setOneToOne1": "*按下開啟一對一聊天按鈕後，機器人會傳送一對一對話招呼語內容，詳細請至",
		"setOneToOne2": "設定頁查看，建議兩者合併使用效果更佳。",
		"openOneToOneConversation": "開啟一對一聊天",
		"noDefault": "尚未填入任何回覆內容",
		"autoAssign" : "自動派工",
		"autoAssignDes" : "您可以設定多組旅遊關鍵字及對應的處理人員，當顧客輸入的觸發語句中包含設定關鍵字時，系統將會自動將顧客分派給相關人員處理。",
		"autoAssignText" : {
			"autoAssignKeyword": {
				"title" : "自動派工關鍵語句",
				"prefix": "我想要去",
				"suffix": "玩！",
				"keyword" : "{預設關鍵字}"
			},
			"autoAssignSetting" : {
				"title" : "自動派工設定",
				"des": "當一個關鍵字同時存在於一位以上的業務底下時，系統將隨機分派顧客給擁有此關鍵字的業務。",
				"chooseOp": "選擇業務",
				"plzChoose": "請選擇",
				"recentKeyword": "常用關鍵字",
				"addSetting" : "新增派工專員",
				"placeholder" : "請至少新增一個關鍵字做為分派依據",
				"viewAllKeyword": "瀏覽所有關鍵字",
				"searchKeyword": "搜尋關鍵字",
				"notFoundKeyword": "尚未建立過此關鍵字",
				"gotoEditKeyword": "前往\"編輯關鍵字\"新增"
 			}
		}
	},
	"user": {
		"subName": "真實姓名",
		"phone": "行動電話",
		"email": "電子信箱",
		"birthday": "生日",
		"remark": "備註",
		"userTags": "顧客標籤",
		"tagsPlaceholder": "輸入標籤 ( 多組以逗號分隔 )，按ENTER新增",
		"userActions": "顧客動態",
		"seeUserActionDetail": "查看顧客詳細資料",
		"addTag": "新增標籤"
	},
	"error": {
		"fileTypeAndSize": "檔案太大",
		"validFail": "驗證失敗",
		"loginFail": "登入失敗"
	},
	"unit": {
		"people": "人",
		"message": "則",
		"friend": "位",
		"NTD": "元",
		"times": "次",
		"tag": "個"
	},
	"login": {
		"login": "登入",
		"logout": "登出",
		"useCowellAccount": "使用科威帳號登入",
		"cowellAccount": "科威帳號登入",
		"account": "帳號",
		"password": "密碼",
		"useGoogleAccount": "使用 Google 帳號登入",
		"privatePolicy": "隱私權政策",
		"termsOfService": "服務條款",
		"loginConfirm": "登入視同您以詳閱並同意本公司之",
		"and": "及",
		"or": "或",
		"googleLogin": "google登入",
		"withCookie": "包含Cookie的使用。",
		"privatePolicyContent": "非常歡迎您使用「」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：\n一、隱私權保護政策的適用範圍\n隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。\n二、個人資料的蒐集、處理及利用方式\n當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。\n本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。\n於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。\n為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。\n三、資料之保護\n本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。\n如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。\n四、網站對外的相關連結\n本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。\n五、與第三人共用個人資料之政策\n本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。\n前項但書之情形包括不限於：\n經由您書面同意。\n法律明文規定。\n為免除您生命、身體、自由或財產上之危險。\n與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。\n當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。\n有利於您的權益。\n本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。\n六、Cookie之使用\n為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行 。\n七、隱私權保護政策之修正\n本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。",
		"termsOfServiceContent": "（以下簡稱本網站）係依據本服務條款提供本站各項服務。當您註冊完成或開始使用本服務時，即表示您已閱讀、了解並同意接受本服務條款之所有內容。如果您不同意本服務條款的內容，或者您所屬的國家或地域排除本服務條款內容之全部或部分時，您應立即停止使用本服務。此外，當您使用本服務之特定功能時，可能會依據該特定功能之性質，而須遵守本服務所另行公告之服務條款或相關規定。此另行公告之服務條款或相關規定亦均併入屬於本服務條款之一部分。本會有權於任何時間修改或變更本服務條款之內容，並公告於本服務網站上，請您隨時注意該等修改或變更。若您於任何修改或變更後繼續使用本服務，則視為您已閱讀、了解並同意接受該等修改或變更。\n若您為未滿二十歲之未成年人，則應請您的父母或監護人閱讀、了解並同意本服務條款之所有內容及其後之修改變更，方得使用本服務。當您使用本服務時，即推定您的父母或監護人已閱讀、了解並同意接受本服務條款之所有內容及其後之修改變更。\n一、隱私權保護政策\n本會相當重視隱私權的保護。關於您的會員註冊以及其他特定資料，將依本服務「隱私權保護政策」保護與規範。您了解並同意當您使用本服務時，本服務可依據「隱私權保護政策」之規範進行您個人資料的蒐集與利用，如線上活動及網路調查等。\n二、一般條款\n本服務條款構成您與本會就您使用本服務之完整合意，取代您先前與本會間有關本服務所為之任何約定。本服務條款之解釋與適用，以及與本服務條款有關的爭議，除法律另有規定者外，均應依照中華民國法律予以處理，並以台灣台北地方法院為管轄法院。\n \n本會未行使或執行本服務條款任何權利或規定，不構成前開權利或規定之棄權。若任何本服務條款規定，經有管轄權之法院認定無效，當事人仍同意法院應努力使當事人於前開規定所表達之真意生效，且本服務條款之其他規定仍應完全有效。\n會員的註冊義務及會員帳號、密碼安全\n為了能使用本服務，您同意並承諾以下事項：\n依本服務註冊流程之提示提供您本人正確及完整的資料，並維持、更新該資料，確保其為正確、最新及完整。\n若您提供任何不完整、錯誤或不實的資料，本會有權暫停或終止您的帳號，並拒絕您使用本服務之全部或部分。\n \n完成本服務的註冊流程後，您將收到一組帳號及密碼。您同意並承諾以下事項：\n此帳號係不可轉讓。\n您有責任維持此帳號及密碼的機密安全。\n當您的帳號遭到盜用或有其他任何安全問題發生時，您將立即通知本會。\n會員使用規範與義務\n除了遵守本服務條款之約定外，您同意遵守中華民國相關法規、本服務其他服務條款，並同意不從事以下行為： 您若係中華民國以外之使用者，並同意遵守所屬國家或地域之相關法規。您同意並保證絕不利用本服務從事違法或損害他人權益之行為。\n冒用他人名義使用本服務。\n侵害他人名譽、隱私權、著作權、智慧財產權及其他權利。\n上載、張貼或公布任何不實、誹謗、侮辱、具威脅性、攻擊性、違背公序良俗、引人犯罪或其他不法之文字、圖片或任何形式的檔案。\n違反依法律或契約所應負之保密義務。\n上載、張貼或公佈任何含有電腦木馬、病毒或任何對電腦軟、硬體產生中斷、破壞或限制功能之程式碼或資料。\n從事販賣槍枝、毒品、禁藥、盜版軟體、其他違禁物或其他不法交易行為。\n破壞及干擾本服務所提供之各項資料、活動或功能，或以任何方式侵入、試圖侵入、破壞本服務之任何系統，或藉由本服務為任何侵害或破壞行為。\n未經同意收集他人電子郵件位址及其他個人資料者。\n其他本會有正當理由認為不適當之行為。\n \n若您有違反前開事項之情事或之虞，本會有權於通知或未通知之情形下，隨時終止或限制您使用帳號（或其任何部分）或本服務之使用，並將本服務內任何相關「會員內容」加以移除並刪除。您同意若本服務之使用被終止或限制時，本會對您或任何第三人均不承擔責任。\n對本服務的貢獻\n若您對於本服務提供任何想法、建議或提議（以下稱「貢獻」）並回饋給本會，您了解並同意：\n該貢獻並非特定機密或專有資訊，且不侵害他人名譽、隱私權、著作權、智慧財產權及其他權利。\n本會對該貢獻並不負有任何明示或默示的保密責任。\n本會可能已有與該貢獻相似而正在考慮或發展中的想法或提案。\n本會可以基於公益或為宣傳、推廣本服務之目的，以任何方式、在任何媒體上使用（或選擇不使用）該貢獻。\n該貢獻將於本會不對您負任何責任的情形下，自動成為本會之財產。您於任何情形下皆無權利對本會主張任何形式的賠償或補償。\n \n若您有違反前開事項之情事或之虞，本會有權於通知或未通知之情形下，隨時終止或限制您使用帳號（或其任何部分）或本服務之使用，並將本服務內任何相關「會員內容」加以移除並刪除。您同意若本服務之使用被終止或限制時，本會對您或任何第三人均不承擔責任。\n不得為商業使用\n您同意並承諾不對本服務任何部分或本服務（包括但不限於會員內容、網站內容、軟體及會員帳號等）之使用或存取，進行任何商業目的之使用。\n您對本服務之授權\n若您無合法權利得授權他人使用、修改、發行、散布、重製或公開展示某資料，並將前述權利轉授權第三人，請勿擅自將該資料上載、輸入或提供予本服務。您所上載、輸入或提供予本服務之任何資料，其權利仍為您或您的授權人所有；但任何資料一經您上載、輸入或提供予本服務時，即表示您已同意授權本會可以基於公益或為宣傳、推廣本服務之目的，進行使用、修改、發行、散布、重製或公開展示該等資料，並得在此範圍內將前述權利轉授權他人。您並保證本服務使用、修改、發行、散布、重製、公開展示或轉授權該資料，不致侵害任何第三人之相關權利，否則應對本會負損害賠償責任。\n系統中斷或故障\n本服務有時可能會出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤等情形。您於使用本服務時宜自行採取防護措施。本會對於您因使用（或無法使用）本服務而造成的損害，不負任何賠償責任。\n與第三方網站之連結及第三方提供之內容\n本服務可能會提供連結至其他機關單位(以下稱「第三方」)之網站。第三方之網站均由各該機關單位自行負責，不屬本服務控制及負責範圍之內。本會對任何檢索結果或外部連結，不擔保其有效性、正確性、合適性、及完整性。您也許會檢索或連結到一些不合適或不需要的網站，遇此情形時，本服務建議您不要瀏覽或儘速離開該等網站。您並同意本會無須為您連結至前述非屬於本服務之網站所生之任何損害，負損害賠償之責任。 本服務隨時會與其他機關單位等第三方（以下稱「內容提供者」）合作，由其提供包括政令、新聞、訊息、活動等不同內容供本服務刊登，且本服務於刊登時均將註明內容來源。基於尊重內容提供者之智慧財產權，本服務對其所提供之內容並不做實質之審查或修改。對該等內容之正確真偽，您宜自行判斷之，本會對該等內容之正確真偽不負任何責任。您若認為某些內容屬不適宜、侵權或有所不實，請逕向該內容提供者反應意見。\n服務變更及通知\n您同意本會保留於任何時間點，不經通知隨時修改、暫時或永久停止繼續提供本服務（或其任一部分）的權利。如依法或其他相關規定須為通知時，本服務得以包括但不限於：張貼於本服務網頁、電子郵件，或其他現在或未來合理之方式通知您，包括本服務條款之變更。但若您違反本服務條款，以未經授權的方式存取本服務，或於註冊時所提供之資料不正確或未更新，您將不會收到前述通知。當您經由授權的方式存取本服務，您即同意本服務所為之任何及所有給您的通知，均視為送達。\n智慧財產權的保護\n本服務所使用之程式、軟體及網站內容，包括但不限於：資訊、資料、圖片、檔案、網站架構、網頁設計及會員內容等，均由本會或其他權利人依法擁有其智慧財產權，包括但不限於專利權、著作權與專有技術等。任何人不得逕自修改、重製、散布、發行、公開發表、進行還原工程或反向組譯。若您欲引用或轉載前述資料，除明確為法律所允許者外，均須依法事前取得本會或其他權利人之書面同意。如有違反，您應負損害賠償責任。\n智慧財產權或著作權之侵害處理\n本會尊重他人之智慧財產權，同樣也要求本服務的使用者尊重他人之智慧財產權。本服務得對於可能屬侵權之使用者暫停或終止其帳戶。若您認為您的著作權或智慧財產權遭受侵害，請提供以下資訊予本服務：\n您的正確資料與聯絡方式，並有異議情形時，同意將其資料提供給被檢舉人。\n能合法代表著作權或智慧財產權利益之所有人之證明。\n您所主張受侵害之著作或其他智慧財產權之描述，以及受侵害資料之描述。\n您基於善意認為該利用未經著作權人其代理人或法律許可之聲明。\n您在了解虛偽陳述之責任的前提下，對於上述載於您的通知上之資訊的正確性之聲明。",
		"dontHaveAccount": "登入帳號遇到困難?請",
		"contactUs": "聯絡我們",
		"backToHome": "回到首頁",
		"chooseTA": "選擇旅行社",
		"next": "下一步"
	},
	"landing": {
		"tutorial": "使用教學",
		"useNow": "立即體驗",
		"exprienceTitle": "打造專屬體驗",
		"exprienceDes": "用對的方式推送對的旅遊資訊，打造專屬每位顧客的體驗服務，為你贏得良好顧客關係。",
		"customerTitle": "讓全台灣 2,100 萬LINE用戶成為你的潛在顧客",
		"customerDes": "連接LINE@及結合真人客服、聊天機器人、顧客標籤分析的廣告推送平台，讓投放廣告工作變成一件簡單的事。",
		"feature1": "平台特色一",
		"featureTitle1": "旅遊專用，科威會員無縫接軌",
		"featureDes1": "針對旅遊業設計，有效顧客名單自動代入，輕鬆打造完善推送資料庫。",
		"feature2": "平台特色二",
		"featureTitle2": "智能客服 QArobot",
		"featureDes2": "運用自然語言理解技術，有效理解顧客語意，能解答來自顧客端80%的重複基礎問題，也能輔助真人客服，人機協作更有效率。",
		"feature3": "平台特色三",
		"featureTitle3": "標籤精準推送",
		"featureDes3": "自動或手動加入顧客標籤，發掘顧客真正需要、喜歡的，讓你的每則訊息都能正中紅心。",
		"plan": "平台方案",
		"planDes": "打造顧客全新一對一或是一對多的體驗服務，讓我們來協助你完成!!",
		"basicPlan": "基礎方案",
		"advancedPlan": "升級方案",
		"aiCustomerService": "一對一智能客服",
		"aiBroadcast": "智能群發訊息",
		"sendMsgByTag": "標籤精準推送",
		"importFromCowell": "科威會員自動匯入",
		"saleWithRobot": "機器人協助銷售",
		"opPermissionControl": "使用者權限分工",
		"onlineShopping": "線上美食商城導入",
		"multipleFuncBots": "更多機器人協助銷售",
		"blackListFilter": "好友黑名單功能",
		"customerAnalysis": "顧客成長數據分析",
		"privatePolicy": "隱私政策",
		"termsOfService": "使用條款",
		"aboutUs": "關於我們"
	},
	"tooltip": {
		"isTop": "已至頂",
		"isBottom": "已至底",
		"maxAnswers": "最多5則回答"
	},
	"liff": {
		"finish": "我填寫好了",
		"cancel": "暫時不想填寫"
	},
	"tutorial" : {
		"notify" : {
			"title" : "Notify 申請步驟",
			"des" : "Notify 是一個透過 LINE 接收其他網站服務通知的功能，完成連動後，LINE 的官方帳號「LINE Notify」將會在顧客傳送訊息的第一時間同步通知指派OP。",
			"step1Title" : "登入 LINE Notify 官網進行設定",
			"step1Des" : "拜訪[LINE Notify](https://notify-bot.line.me/zh_TW/)，登入您的個人帳號並點擊右上方帳號暱稱開啟選單，選擇**個人頁面**進入設定頁。",
			"step2Title" : "取得並複製權杖",
			"step2Des" : "滑至下方的 **發行存取權杖（開發人員用）** 點擊![發行權杖](https://lineline.s3.ap-northeast-2.amazonaws.com/line-notify-tutorial-images/step2_issuedkey.png)" +
				"系統會跳出設定框，填寫**權杖名稱**及選擇接收通知用的**聊天室**（ 1 對 1 聊天接收 LINE Notify 或是群組聊天室）後，" +
				"按下![發行](https://lineline.s3.ap-northeast-2.amazonaws.com/line-notify-tutorial-images/step2_issued.png)，" +
				"設定框會顯示專屬於您的權杖，選擇![複製](https://lineline.s3.ap-northeast-2.amazonaws.com/line-notify-tutorial-images/step2_copy.png)即可將權杖複製到剪貼簿。"+
				"  \n權杖須妥善保存並轉交給 line bagel 系統管理員進行**步驟4**設定。",
			"step3Title" : "LINE Notify 啟用完成的顯示",
			"step3DesPart1" : "可於下面 2 個地方看到 LINE Notify 是否完成啟用：",
			"step3DesPart2" : "1. 指定接收的帳號會收到一則 LINE Notify 自動加入好友訊息。",
			"step3DesPart3" : "2. 步驟 1 的個人頁面中已連動服務可看到您的接收帳號。",
			"step4Title" : "line bagel 系統管理員設定",
			"step4Des" : "管理員取得 OP / 業務專屬權杖字串後，請進入line bagel 系統 [**組織設定**]({{settingUrl}})頁面，" +
				"滑至下方的組織成員尋找到 OP / 業務對應的 Google 帳號，於他的 Notify 存取權杖欄位貼上權狀字串即可。",
			"step5Seq" : "預覽未來",
			"step5Title" : "訊息示意",
			"step5Des" : "2 個系統 ( LINE Notify、line bagel ) 設定完成後，未來只要顧客於傳送訊息，該負責 OP / 業務 ( 使用指派功能 ) 就會在第一時間收到 LINE Notify 通知有顧客訊息需回覆，有效提升服務品質。"
		}
	},
	"weekday": {
		"monday": "星期一",
		"tuesday": "星期二",
		"wednesday": "星期三",
		"thursday": "星期四",
		"friday": "星期五",
		"saturday": "星期六",
		"sunda": "星期日",
	},
	"set": "設定",
	"unset": "未設定",
	"confirm": "確定",
	"cancel": "取消",
	"close": "關閉",
	"back": "返回",
	"copy": "複製",
	"invite": "邀請",
	"save": "儲存",
	"success": "成功",
	"fail": "失敗",
	"delete": "刪除",
	"update": "更新",
	"search": "搜尋",
	"plzSelect": "請選擇",
	"select": "選擇",
	"loadmore": "載入更多",
	"send": "發送",
	"upload": "上傳",
	"edit": "編輯",
	"preview": "預覽",
	"submit": "送出",
	"deleteConfirm": "您確定要刪除嗎？",
	"saving": "儲存中....",
	"saved": "儲存完成",
	"download": "下載",
	"goNow": "立即前往",
	"understand": "了解"
}

export default zhTW
